import sensedia from './sensedia'
import sensediaCustom from './sensediaCustom'

const OAuthService = {
  async requestSensediaToken() {
    const auth = {
      headers: {'Content-Type':'application/x-www-form-urlencoded'}
    }
    const res = await sensedia.client.post('/oauth/access-token?grant_type=client_credentials',{}, auth)
    return res.data
  },
  async requestSensediaTokenCustom() {
    const auth = {
      headers: {'Content-Type':'application/x-www-form-urlencoded'}
    }
    const res = await sensediaCustom.client.post('/oauth/access-token?grant_type=client_credentials',{}, auth)
    return res.data
  },
  async repeatRequestSensedia(previousRequestPath, previousRequestParams, previousRequestType, headersMap) {
    if (previousRequestType === 'get') {
      return await sensedia.client.get(previousRequestPath, {})
    }

    return await sensedia.client.post(previousRequestPath, previousRequestParams, headersMap)
  },
}

export default OAuthService



// WEBPACK FOOTER //
// ./src/services/state/middlewares/axios/clients/OAuthService.js